import { render } from "./DaiwariCopyReference.vue?vue&type=template&id=2929136a&scoped=true"
import script from "./DaiwariCopyReference.vue?vue&type=script&lang=js"
export * from "./DaiwariCopyReference.vue?vue&type=script&lang=js"

import "./DaiwariCopyReference.vue?vue&type=style&index=0&id=2929136a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2929136a"]])

export default __exports__